var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 20.25C33.75 19.8522 33.592 19.4706 33.3107 19.1893C33.0294 18.908 32.6478 18.75 32.25 18.75H22.5L20.7 16.35C20.5603 16.1637 20.3791 16.0125 20.1708 15.9084C19.9625 15.8042 19.7329 15.75 19.5 15.75H15.75C15.3522 15.75 14.9706 15.908 14.6893 16.1893C14.408 16.4706 14.25 16.8522 14.25 17.25V30.75C14.25 31.1478 14.408 31.5294 14.6893 31.8107C14.9706 32.092 15.3522 32.25 15.75 32.25H32.25C32.6478 32.25 33.0294 32.092 33.3107 31.8107C33.592 31.5294 33.75 31.1478 33.75 30.75V20.25Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/custom-icon.623be3b680bdfc15c46f86ec2f2b0175.svg";
export { ForwardRef as ReactComponent };